module.exports = __webpack_public_path__ + "img/PG.4fc4981b.jpg";